import React from 'react';
import '../css/LegalPages.css';

const About = () => {
  return (
    <div className="legal-container">
      <h1>Hakkımızda</h1>

      <section>
        <h3>1. Halısahacım Nedir?</h3>
        <p>
          Halısahacım, Türkiye genelindeki halı saha işletmelerini ve futbol severleri tek bir dijital platformda bir araya getiren
          modern bir rezervasyon, iletişim ve yönetim sistemidir. Platform; kullanıcıların kolayca müsait saat araması yapmasını,
          online rezervasyon oluşturmasını, işletmelerle iletişim kurmasını ve oynadıkları maçlara ait videolara erişebilmesini sağlar.
        </p>
        <p>
          İşletmeler için ise gelişmiş yönetim araçları, rezervasyon takibi, müşteri iletişimi, maç kayıt görüntüleme ve tanıtım
          görünürlüğü sunarak operasyonel süreçlerini kolaylaştırır.
        </p>
      </section>

      <section>
        <h3>2. Kuruluş Amacımız</h3>
        <p>
          Halı saha kültürünü dijitalleştirmek, işletmeler ile oyuncular arasındaki iletişimi hızlı, şeffaf ve güvenilir hale getirmek
          amacıyla yola çıktık. Modern teknolojiyi kullanarak, hem bireysel kullanıcıların hem de işletmelerin yaşamını kolaylaştıran,
          kesintisiz bir futbol deneyimi sunmayı hedefliyoruz.
        </p>
      </section>

      <section>
        <h3>3. Sunulan Hizmetler</h3>
        <ul>
          <li>📌 Türkiye genelinde halı saha arama ve filtreleme</li>
          <li>📌 Gerçek zamanlı müsait saat görüntüleme</li>
          <li>📌 Online rezervasyon sistemi</li>
          <li>📌 Oyuncu bulma, rakip bulma ve takım arama modülleri</li>
          <li>📌 İşletmelere özel rezervasyon, mesajlaşma ve abone yönetimi</li>
          <li>📌 Maç kayıtlarının platforma yüklenmesi ve izlenebilmesi</li>
          <li>📌 Kullanıcı puanlama ve değerlendirme sistemi</li>
          <li>📌 Topluluk bölümünde en iyi gollerin paylaşılması</li>
        </ul>
        <p>
          Tüm bu hizmetler, kullanıcı deneyimini en üst seviyeye taşımak ve işletmelerin dijitalleşme süreçlerine katkı sağlamak amacıyla tasarlanmıştır.
        </p>
      </section>

      <section>
        <h3>4. Vizyonumuz</h3>
        <p>
          Türkiye'nin en kapsamlı dijital spor platformu haline gelmek ve halı saha ekosisteminin tüm bileşenlerini tek çatı altında
          toplayan, yenilikçi ve sürdürülebilir bir hizmet ağı oluşturmaktır.
        </p>
      </section>

      <section>
        <h3>5. Misyonumuz</h3>
        <p>
          Kullanıcıların güvenli, hızlı ve kolay bir futbol deneyimi yaşamasını sağlamak; işletmelere ise işlerini büyütmeleri için
          dijital araçlar sunmak. Teknolojiyi herkesin erişebileceği şekilde sade, anlaşılır ve verimli hâle getirmek temel önceliğimizdir.
        </p>
      </section>

      <section>
        <h3>6. Güvenlik ve KVKK İlkelerimiz</h3>
        <p>
          Halısahacım olarak kullanıcı bilgilerinin güvenliği en yüksek önceliğimizdir. Tüm veriler, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK)
          ve ilgili sair mevzuata uygun şekilde işlenmekte, üçüncü kişilerle paylaşılmamaktadır. 
          Veriler yalnızca hizmetin sunumu için gerekli olduğu ölçüde kullanılmaktadır.
        </p>
        <p>
          Gizlilik Politikası ve KVKK Aydınlatma Metni’nde kişisel verilerin işlenme amaçları, saklama süreleri ve kullanıcı hakları
          açıkça belirtilmiştir.
        </p>
      </section>

      <section>
        <h3>7. İletişim</h3>
        <p>
          Görüş, öneri ve talepleriniz için bize her zaman ulaşabilirsiniz:
        </p>
        <p>
          📧 <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a>
        </p>
      </section>
    </div>
  );
};

export default About;
